// Copyright 2025-2026 NXGN Management, LLC. All Rights Reserved.
import { ReactNode } from 'react'
import { NextGenTheme, lightTheme } from '@teamnine/pcj-ui-v2'
import { createGlobalStyle } from 'styled-components'

import '@teamnine/pcj-ui-v2/dist/pcj-ui-v2.css'
import 'material-symbols/outlined.css'
import './fonts.css'

type AppThemeProps = {
  children: ReactNode
}

export type AppThemeType = typeof lightTheme

const AppGlobals = createGlobalStyle`
  #root {
    height: 100%;
  }
`

export default function AppTheme({ children }: AppThemeProps): JSX.Element {
  return (
    <NextGenTheme>
      <AppGlobals />
      {children}
    </NextGenTheme>
  )
}
